import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_item_far_depreciation_event_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    fi_item_far_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    depr_method: fromDatatype.VarcharDatatypeInterface;
    residual_value: fromDatatype.NumericDatatypeInterface;
    depr_ave_method: fromDatatype.VarcharDatatypeInterface;
    depr_rate: fromDatatype.NumericDatatypeInterface
    useful_life: fromDatatype.NumericDatatypeInterface
    fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
    fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
    fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
    fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_item_far_depreciation_event_RowClass implements bl_fi_mst_item_far_depreciation_event_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    fi_item_far_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    depr_method: fromDatatype.VarcharDatatypeInterface;
    residual_value: fromDatatype.NumericDatatypeInterface;
    depr_ave_method: fromDatatype.VarcharDatatypeInterface;
    depr_rate: fromDatatype.NumericDatatypeInterface
    useful_life: fromDatatype.NumericDatatypeInterface
    fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
    fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
    fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
    fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}